/* @flow */

import React, { Component } from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import t from 'app/utils/translate';
import { noop } from 'lodash/fp';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import FriendSearchBar from 'app/components/commons/FriendSearchBar';
import IconButton from 'app/components/commons/IconButton';
import Tappable from 'app/components/commons/Tappable';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';

type Props = {
  classes: Object,
  onSearchChange: (terms: string) => void,
  onSearchStart?: () => void,
  onSearchEnd?: () => void,
  className?: string,
  isSearching?: boolean,
  searchTerm: string,
};

type State = {
  isSearching: boolean,
};

class GroupContainerSearch extends Component<Props, State> {
  props: Props;
  state: State = {
    isSearching: false,
  };

  static defaultProps = {
    onSearchStart: noop,
    onSearchEnd: noop,
    className: undefined,
    isSearching: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isSearching !== this.props.isSearching) {
      this.setState({ isSearching: nextProps.isSearching });
    }
  }

  resetSearch = () => {
    this.setState({ isSearching: false });
    this.props.onSearchChange('');
    this.props.onSearchEnd();
  };

  onSearchChange = (text: string) => {
    this.props.onSearchChange(text);
  };

  onSearchStart = () => {
    this.props.onSearchStart();
    this.setState({ isSearching: true });
  };

  render() {
    const { classes, className, searchTerm } = this.props;
    const { isSearching } = this.state;
    return (
      <div className={classNames(classes.searchBlock, className)}>
        <IconButton
          onClick={this.onSearchStart}
          className={classNames({ [classes.searchActive]: isSearching })}
          type="icon-search"
        />
        <div className={classes.search}>
          <FriendSearchBar
            value={searchTerm}
            onSearch={this.onSearchChange}
            onBeginSearch={this.onSearchStart}
            placeholder={t('Search Friends')}
            editMode={false}
            condensed
            scheme="dark"
          />
        </div>
        <AnimatedGroup onEnter={Enter.appear(0.3)} onLeave={Leave.disappear(0.3)}>
          {isSearching && (
            <Tappable onTap={this.resetSearch} className={classes.cancelButton}>
              {t('Cancel')}
            </Tappable>
          )}
        </AnimatedGroup>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    cancelButton: {
      paddingTop: 2,
    },
    searchBlock: {
      display: 'flex',
      alignItems: 'center',
      color: theme.color.basis4,
      fontSize: 14,
      [theme.mediaQuery.mobileOnly]: {
        fontSize: 16,
      },
    },
    searchActive: {
      color: theme.color.primary,
    },
    search: {
      flexGrow: 1,
      paddingLeft: 5,
      paddingRight: 5,
    },
  };
}

export default useSheet(applyStyles)(GroupContainerSearch);
